(() => {
  if (window.__rbCardSlider) return;
  window.__rbCardSlider = true;
  const CSS_URL = document.currentScript && document.currentScript.dataset.css;

  const ensureCss = () => {
    if (!CSS_URL || document.getElementById('rb-sliders-css')) return;
    const link = document.createElement('link');
    link.id = 'rb-sliders-css';
    link.rel = 'stylesheet';
    link.href = CSS_URL;
    document.head.appendChild(link);
  };

  const icon = (path) =>
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="' + path + '"/></svg>';

  const cache = new Map();
  const getProduct = (handle) => {
    if (!cache.has(handle)) {
      cache.set(
        handle,
        fetch('/products/' + handle + '.js')
          .then((response) => (response.ok ? response.json() : null))
          .catch(() => null)
      );
    }
    return cache.get(handle);
  };

  const handleOf = (card) => {
    const link = card.querySelector('a.full-unstyled-link[href*="/products/"]');
    if (!link) return null;
    const match = new URL(link.href, window.location.origin).pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  };

  const sized = (url, width) => {
    try {
      const u = new URL(url, window.location.origin);
      u.searchParams.set('width', width);
      return u.toString();
    } catch (error) {
      return url;
    }
  };

  const build = (card, inner, img, images, title) => {
    card.dataset.rbSlider = 'ready';
    ensureCss();
    let index = 0;
    const root = document.createElement('div');
    root.className = 'rb-cs';
    const prev = document.createElement('button');
    const next = document.createElement('button');
    prev.type = next.type = 'button';
    prev.className = 'rb-cs__btn rb-cs__btn--prev';
    next.className = 'rb-cs__btn rb-cs__btn--next';
    prev.setAttribute('aria-label', 'Previous image of ' + title);
    next.setAttribute('aria-label', 'Next image of ' + title);
    prev.innerHTML = icon('M15 5l-7 7 7 7');
    next.innerHTML = icon('M9 5l7 7-7 7');
    const dots = document.createElement('div');
    dots.className = 'rb-cs__dots';
    dots.setAttribute('aria-hidden', 'true');
    images.forEach(() => dots.appendChild(document.createElement('span')).className = 'rb-cs__dot');
    root.append(prev, next, dots);
    card.appendChild(root);

    const measure = () => card.style.setProperty('--rb-media-h', inner.getBoundingClientRect().height + 'px');
    measure();
    if (window.ResizeObserver) new ResizeObserver(measure).observe(inner);

    const show = (n) => {
      index = (n + images.length) % images.length;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = sized(images[index], 720);
      img.alt = title + ' (' + (index + 1) + ' / ' + images.length + ')';
      Array.from(dots.children).forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      const upcoming = new Image();
      upcoming.src = sized(images[(index + 1) % images.length], 720);
    };
    show(0);

    let suppress = false;
    const step = (event, direction) => {
      event.preventDefault();
      event.stopPropagation();
      show(index + direction);
    };
    prev.addEventListener('click', (event) => step(event, -1));
    next.addEventListener('click', (event) => step(event, 1));
    card.addEventListener('click', (event) => {
      if (suppress) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);

    let startX = 0;
    let startY = 0;
    inner.addEventListener('touchstart', (event) => {
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });
    inner.addEventListener('touchend', (event) => {
      const dx = event.changedTouches[0].clientX - startX;
      const dy = event.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        show(index + (dx < 0 ? 1 : -1));
        suppress = true;
        setTimeout(() => (suppress = false), 400);
      }
    }, { passive: true });
  };

  const enhance = (card) => {
    if (card.dataset.rbSlider) return;
    card.dataset.rbSlider = 'pending';
    const handle = handleOf(card);
    const inner = card.querySelector('.card__inner');
    const img = card.querySelector('.card__media .media img');
    if (!handle || !inner || !img) {
      card.dataset.rbSlider = 'skip';
      return;
    }
    getProduct(handle).then((product) => {
      if (!product || !product.images || product.images.length < 2) {
        card.dataset.rbSlider = 'single';
        return;
      }
      build(card, inner, img, product.images.slice(0, 6), product.title);
    });
  };

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          enhance(entry.target);
        }
      }), { rootMargin: '200px' })
    : null;

  const scan = (root) => (root || document).querySelectorAll('.card-wrapper.product-card-wrapper').forEach((card) => {
    if (card.dataset.rbSlider) return;
    if (observer) observer.observe(card);
    else enhance(card);
  });

  let queued = false;
  const queueScan = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      scan();
    });
  };

  const start = () => {
    scan();
    new MutationObserver(queueScan).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();